import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const PaymentCancelled = () => {
  const [params] = useSearchParams();
  const orderId = params.get('order_id');

  return (
    <div
      data-testid="payment-cancelled-page"
      className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-16 flex items-center"
    >
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <Card className="border-2 shadow-2xl">
          <CardContent className="pt-12 pb-12 text-center">
            <XCircle className="w-20 h-20 text-orange-500 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-gray-900 mb-3">Payment cancelled</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              No worries — your order is safe. You can complete payment any time using the link in your email, or contact us if you need a fresh link.
            </p>
            {orderId && (
              <p className="text-xs text-gray-400 mb-6">Reference: {orderId}</p>
            )}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/">
                <Button variant="outline" className="w-full sm:w-auto">Back to Home</Button>
              </Link>
              <a href="mailto:info@thelokal.ca">
                <Button className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold w-full sm:w-auto">
                  Contact Us
                </Button>
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancelled;
